import styles from "./SupplierServices.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import Modal from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
import { useState } from "react";

const openingHours = [
  ["Monday to Friday", "8am - 9pm"],
  ["Saturday", "8am - 8pm"],
  ["Sunday", "10am - 6pm"],
];
export const SupplierServicesUI = () => {
  const [isOpen, toggleOpen] = useState(false);
  return (
    <Message
      title={" "}
      body={
        <div>
          <p
            data-testid="supplierServicesMessage"
            data-cy="supplier-direct-message"
          >
            If you need installation or recycling services with this product,
            please do not order online. Call our Customer Services Team on{" "}
            <a
              href="tel:03456048835"
              className={styles.SupplierServices__phoneNumber}
            >
              0345 604 8835
            </a>{" "}
            and we&apos;ll place your order for you.
            <Modal
              isOpen={isOpen}
              onClose={() => toggleOpen(false)}
              header="Contact centre opening hours"
              rootId="page-root"
            >
              {openingHours.map(([days, times]) => (
                <div className={styles.SupplierServices__row} key={days}>
                  <div className={styles.SupplierServices__days}>{days}</div>
                  <div className={styles.SupplierServices__times}>{times}</div>
                </div>
              ))}
            </Modal>
          </p>
          <UnderlinedButton inline onClick={() => toggleOpen(true)}>
            View contact centre opening hours
          </UnderlinedButton>
        </div>
      }
      type={"information"}
    />
  );
};
